class ProductCarouselManager {
  constructor() {
    this.carousels = document.querySelectorAll('.product-slider');
    this.init();
  }

  init() {
    this.carousels.forEach(carousel => this.setupCarousel(carousel));
    this.setupResizeHandler();
  }

  setupCarousel(item) {
    const carousel = item.querySelector('.carousel');
    if (!carousel) return;

    carousel.addEventListener('carousel:initialized', () => {
      this.updateCarouselHeight(item, carousel);
    });
  }

  updateCarouselHeight(item, carousel) {
    if (!this.isCarouselInitialized(carousel)) return;

    const imageHeight = this.getFirstImageHeight(carousel);
    const navWrapperHeight = this.getNavWrapperHeight(item);
    const buttonHeight = this.getButtonHeight(item);

    this.setCarouselHeight(
      item,
      (imageHeight / 2) - (buttonHeight / 2) + navWrapperHeight
    );
  }

  isCarouselInitialized(carousel) {
    return carousel.classList.contains('swiper-initialized');
  }

  getFirstImageHeight(carousel) {
    const firstSlide = carousel.querySelector('.carousel__slide');
    const firstImage = firstSlide?.querySelector('.image');
    return firstImage?.offsetHeight || 0;
  }

  getNavWrapperHeight(item) {
    const navWrapper = item.querySelector('.carousel__navigation-wrapper');
    return navWrapper ? navWrapper.offsetHeight : 0;
  }

  getButtonHeight(item) {
    const button = item.querySelector('.carousel__navigation-button');
    return button ? button.offsetHeight : 0;
  }

  setCarouselHeight(item, height) {
    const navWrapper = item.querySelector('.carousel__navigation-wrapper');
    if (navWrapper) {
      navWrapper.style.setProperty('--carousel-button-top', `${height}px`);
    }
  }

  setupResizeHandler() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.carousels.forEach(item => {
          const carousel = item.querySelector('.carousel');
          if (carousel) {
            this.updateCarouselHeight(item, carousel);
          }
        });
      }, 100); // Debounce resize events
    });
  }
}

// Initialize the carousel manager
new ProductCarouselManager();
